import { render, staticRenderFns } from "./InvoiceTypeList.vue?vue&type=template&id=ea82b65c&scoped=true&lang=pug&"
import script from "./InvoiceTypeList.vue?vue&type=script&lang=ts&"
export * from "./InvoiceTypeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea82b65c",
  null
  
)

export default component.exports